import { DeliveryResolver } from "./DeliveryResolver";
import { milkmanFreshFoodStore } from "../../store/milkmanFreshFoodStore";
import { MilkmanDeliveryResolver } from './MilkmanDeliveryResolver'
import _ from 'lodash'

export class MilkmanFreshFoodDeliveryResolver extends MilkmanDeliveryResolver {
  timeRangeEnabled = true;
  store = milkmanFreshFoodStore
  state = milkmanFreshFoodStore.state
}
